import { Directive, input } from '@angular/core';
import { BaseModel } from '../../../../../models/entity/base/base.model';

@Directive()
export abstract class EntityListCellComponent<T extends BaseModel> {
  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  readonly entity = input.required<T>();
}
